module.exports = "<div class=\"app-wrapper\">\n\t<router-view></router-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/app-root.html
// module id = 110
// module chunks = 0